import { TOGGLE_STOPLISTONLY } from './types'

export const toggleStoplistOnly = _ => ({
  type: TOGGLE_STOPLISTONLY
})
